import q from 'q';
import CONF from './../config/config.js';
import { sendEventToHevo2 } from './manageEvents.js';

var token;
var facilityId;
var userId;
var user = JSON.parse(localStorage.getItem('user'));
var selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));

if (user) {
    token = 'Bearer ' + user.accessToken;
    userId = user.bradmanUserProfile.emailId;
}
if (selectedFacility) {
    facilityId = selectedFacility.facilityId;
}

var exactUrl = process.env.REACT_APP_API_URL;

var sendErrorEvent = function (apiPath, method, resp, case_num) {
    let req = {};

    if (apiPath) {
        req.api_path = apiPath;
    }

    if (case_num) {
        req.function_key = case_num;
    }

    if (method && method.method) {
        req.method = method.method;
    }

    if (resp) {
        if (resp.error && resp.error.error) {
            //console.log(resp.error.error);
            req.error_message = resp.error.error;
        }
        if (resp.statusText) {
            //console.log(resp.statusText);
            req.error_message = resp.statusText;
        }
        if (resp.message) {
            //console.log(resp.message);
            req.error_message = resp.message;
        }

        if (resp.statusCode) {
            //console.log(resp.statusCode);
            req.status_code = resp.statusCode;
        }
        if (resp.status) {
            //console.log(resp.status);
            req.status_code = resp.status;
        }
    }

    sendEventToHevo2(req);
};

const createMethodObject = (obj, content) => {
    const fetchMethod = {
        ...obj,
        headers: {},
    };
    fetchMethod.headers['Accept'] = '*/*';
    if (user) {
        fetchMethod.headers['Authorization'] = token;
        fetchMethod.headers['userid'] = userId;
    }
    if (facilityId) {
        fetchMethod.headers['facilityid'] = facilityId;
    }
    if (content) {
        fetchMethod.headers['content-type'] = content;
    }
    return fetchMethod;
};

var http = function (tinurl, method, content) {
    var url = exactUrl + CONF.BRADMAN_END_POINT + tinurl; // prod
    // var url = CONF.BRADMAN_END_POINT + tinurl; // localhost
	const methodObj = createMethodObject(method, content);

    var deferred = q.defer();
    fetch(url, methodObj)
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            if (response.statusCode && response.statusCode !== 200) {
                sendErrorEvent(tinurl, method, response, 1);
                deferred.reject({ error: response.error });
                return;
            }
            if (response.code && response.code !== 200) {
                sendErrorEvent(tinurl, method, response, 2);
                var error = {
                    error: response.message,
                };
                deferred.reject({ error: error });
                return;
            }
            if (response.data) {
                deferred.resolve(response.data);
            } else {
                deferred.resolve(response);
            }
        })
        .catch(function (e) {
            sendErrorEvent(tinurl, method, e, 3);
            deferred.reject(e);
        });
    return deferred.promise;
};

var httpPostBlob = function (tinurl, method, content) {
    var deferred = q.defer();
    var url = exactUrl + CONF.BRADMAN_END_POINT + tinurl;
    const methodObj = createMethodObject(method, content);

    fetch(url, methodObj)
        .then((response) => {
            if (response.status !== 200) {
                return response.json();
            }
            return response;
        })
        .then(function (response) {
            if (response.statusCode && response.statusCode !== 200) {
                sendErrorEvent(tinurl, method, response, 4);
                deferred.reject({ error: response.error });
                return;
            }
            if (response.data) {
                deferred.resolve(response.data);
            } else {
                var data = response;
                var mime = response.headers.get('Content-Type');
                var fileName = response.headers
                    .get('Content-Disposition')
                    .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                var name = fileName[1];
                deferred.resolve({ data: data, mime: mime, name: name });
            }
        })
        .catch(function (e) {
            sendErrorEvent(tinurl, method, e, 5);
            deferred.reject(e);
        });
    return deferred.promise;
};

// TODO: can we combine this and httpPostBlob method into one
var fileDownloadHttp = function (tinurl, method, content) {
    var deferred = q.defer();
    var url = exactUrl + CONF.BRADMAN_END_POINT + tinurl;
    // var url = CONF.BRADMAN_END_POINT + tinurl; // localhost
    const methodObj = createMethodObject(method, content);

    fetch(url, methodObj)
        .then((response) => {
            if (response.status !== 200) {
                sendErrorEvent(tinurl, method, response, 6);
                deferred.reject(new Error(`HTTP ${response.status}`));
                return;
            }
            var data = response;
            var mime = response.headers.get('Content-Type');
            var fileName = response.headers
                .get('Content-Disposition')
                .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            var name = fileName[1];
            deferred.resolve({ data: data, mime: mime, name: name });
        })
        .catch(function (e) {
            deferred.reject(e);
        });
    return deferred.promise;
};

const fileUploads3Http = (url, method) => {
    return new Promise((resolve, reject) => {
        fetch(url, method)
            .then((res) => {
                resolve(res.headers.get('etag'));
            })
            .catch((err) => reject(err));
    });
};

const apiHandler = {
    post: function (url, data) {
        return http(
            url,
            { method: 'POST', body: JSON.stringify(data) },
            'application/json'
        );
    },

    postIngestion: function (url, data) {
        return http(url, { method: 'POST', body: data });
    },

    postIngestionBlob: function (url, data) {
        return httpPostBlob(url, { method: 'POST', body: data });
    },

    put: function (url, data) {
        return http(
            url,
            { method: 'PUT', body: JSON.stringify(data) },
            'application/json'
        );
    },

    // Alias to make GET API http calls.
    get: function (url, params) {
        return http(url, { method: 'GET' }, 'application/json');
    },

    fileDownloadHttpGet: function (url, params) {
        return fileDownloadHttp(url, { method: 'GET', params: params });
    },
	uploadFileToS3: function(url, data) {
		return fileUploads3Http(url, { method: 'PUT', body: data, headers: { 'content-type' : 'application/pdf' } });
	},

    getAppVersions: function (appTenantName) {
        return http(`bradman/app-versions?appTenantName=${encodeURIComponent(appTenantName)}`, { method: 'GET' }, 'application/json');
    },

    getAppRelease: function (appTenantName, appVersionName) {
        return http(`bradman/app/release/version?appTenantName=${encodeURIComponent(appTenantName)}&appVersionName=${encodeURIComponent(appVersionName)}`, { method: 'GET' }, 'application/json');
    },

};

export default apiHandler;



// WEBPACK FOOTER //
// ./src/utilities/apiHandler.js